import { AbstractControl, ValidationErrors } from "@angular/forms";

export function isSelected(control: AbstractControl) : ValidationErrors|null{
    let isSelected = (control.value || false) === true;
    return isSelected ? null : {'unselected': true}
}